<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('SeaExport.EditSopStatus')"
    width="735px"
    :close-on-click-modal="false"
  >
    <el-form style="display: flex;flex-direction: row;">
      <el-form-item>
        <el-select v-model="sopTemplateKey" no="sopTemplateKey" :placeholder="$t('SeaExport.PleaseSelectATemplate')" style="width:120px" @change="getTracking">
          <el-option v-for="(item,index) in availableSopTemplates" :key="index" :label="item.templateName" :value="item.uuid" />
        </el-select>
        <el-select v-model="trackingCode" no="trackingCode" :placeholder="$t('SeaExport.PleaseSelectANode')" style="width:120px" @change="getTrackingDetail">
          <el-option v-for="(item,index) in availableTrackingList" :key="index" :label="item.codeCname" :value="item.code" />
        </el-select>
        <el-select v-model="trackingDetailCode" no="trackingDetailCode" :placeholder="$t('SeaExport.PleaseSelectAState')" style="width:140px">
          <el-option v-for="(item,index) in trackingDetailList" :key="index" :label="item.codeCname" :value="item.code" />
        </el-select>
        <el-date-picker
          :value="trackingDetailDate || new Date()"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm"
          format="yyyy-MM-dd HH:mm"
          style="width:180px"
          :placeholder="$t('SeaExport.SelectTime')"
          @input="val => { trackingDetailDate = val }"
        />
        <el-input v-model="trackingDetailRemark" style="width:150px" />
      </el-form-item>
    </el-form>
    <div style="display: flex;">
      <div style="display: flex;flex-direction: column;">
        <el-checkbox v-model="messageChecked">{{ $t('Message.SendStatusChangeNotification') }}</el-checkbox>
      </div>
      <div style="display: flex;flex-direction: column; padding-left:10px;">
        <span style="padding-top: 2.5px">{{ '*' + $t('Message.OptionIsChecked') }}</span>
      </div>
    </div>
    <div slot="footer" style="margin: 0 auto;width: fit-content;">
      <el-button no="confirm" type="primary" @click="confirmEditState">{{ $t('common.btn.confirm') }}</el-button>
      <el-button no="cancel" @click="innerVisible = false">{{ $t('common.btn.cancel') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import { queryTenantAllSopTemplate } from '@/api/sysManage/baseConfig/businessManage'
import { updateJobTrackingInfo } from '@/api/seaExport/seaExportJob'

export default {
  name: 'StateDialog',
  props: {
    visible: { type: Boolean, required: true },
    rows: { type: Array, default: () => [] },
    trackingList: { type: Array, default: () => [] }
  },
  data() {
    return {
      innerVisible: false,
      sopTemplateKey: '',
      trackingCode: '',
      trackingDetailCode: '',
      trackingDetailDate: '',
      trackingDetailRemark: '',
      messageChecked: true,
      sopTemplates: [],
      availableTrackingList: [],
      trackingDetailList: []
    }
  },
  computed: {
    availableSopTemplates() {
      if (this.rows.length > 0) {
        const lob = this.rows[0].lob
        // if (lob === 'RI') {
        //   lob = 'RE'
        // }
        return this.sopTemplates.filter(item => item.lob === lob)
      }
      return []
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(newVal) {
        this.innerVisible = newVal
        if (newVal) {
          queryTenantAllSopTemplate().then(res => {
            this.sopTemplates = res.data
          })
        }
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
      if (!newVal) {
        this.sopTemplateKey = ''
        this.trackingCode = ''
        this.trackingDetailCode = ''
        this.trackingDetailDate = ''
        this.trackingDetailRemark = ''
        this.messageChecked = true
        this.sopTemplates = []
        this.trackingDetailList = []
      }
    }
  },
  methods: {
    getTracking(templateKey) {
      this.trackingCode = ''
      this.trackingDetailCode = ''
      this.availableTrackingList = this.trackingList.filter(item => item.trackingTemplateUuid === templateKey)
      this.trackingDetailList = []
    },
    getTrackingDetail(trackingCode) {
      this.trackingDetailCode = ''
      this.trackingDetailList = []
      const trackingList = this.trackingList.filter(item => item.code === trackingCode && item.trackingTemplateUuid === this.sopTemplateKey)
      this.trackingDetailList = trackingList[0].trackingDetail
    },
    // 确认修改
    confirmEditState() {
      const sopTemplateKey = this.sopTemplateKey
      const trackingCode = this.trackingCode
      const trackingDetailCode = this.trackingDetailCode
      if (!sopTemplateKey) {
        this.$message.warning(this.$t('SeaExport.PleaseSelectATemplate'))
        return
      }
      if (trackingCode === '') {
        this.$message.warning(this.$t('Message.PleaseSelectABusinessStatus'))
        return
      }
      if (trackingDetailCode === '') {
        this.$message.warning(this.$t('Message.PleaseSelectABusinessStatusDetails'))
        return
      }
      const trackingDetailRemark = this.trackingDetailRemark
      const trackingDetailDate = this.trackingDetailDate
      const messageChecked = this.messageChecked
      const jobKeys = []
      for (const row of this.rows) {
        if (row.trackingTemplateUuid === sopTemplateKey) {
          jobKeys.push(row.uuid)
        }
      }
      if (jobKeys.length === 0) {
        this.updateJobTrackingInfoResult(0)
        return
      }
      const loading = getLoading4Cxt(this)
      updateJobTrackingInfo({
        jobKeys, trackingCode, trackingDetailCode, trackingDetailRemark, messageChecked, trackingDetailDate
      }).then(res => {
        this.updateJobTrackingInfoResult(res.data)
      }).finally(() => {
        loading.close()
      })
    },
    updateJobTrackingInfoResult(result) {
      this.innerVisible = false
      this.$message.success(this.$t('SeaExport.SuccessModifiedXBusinessState', [result]))
      this.$emit('callback')
    }
  }
}
</script>
